import React from "react";
import { Crown } from "@phosphor-icons/react";

/**
 * VipKingBadge — a small gold "VIP KING 👑" pill shown next to a user's name
 * when they hold an active VIP credit. Variants:
 *  - "default": gold gradient pill (use on light backgrounds)
 *  - "dark": warm-on-dark pill (use on dark chat headers)
 *  - "compact": just the crown icon (use in tight spaces)
 */
export default function VipKingBadge({ variant = "default", label = "VIP KING", className = "" }) {
  if (variant === "compact") {
    return (
      <span
        className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-gradient-to-br from-amber-300 to-amber-500 text-[#3F2D1B] shadow-sm ${className}`}
        title="VIP King"
        data-testid="vip-king-badge"
      >
        <Crown size={11} weight="fill" />
      </span>
    );
  }
  const skin =
    variant === "dark"
      ? "bg-amber-300/15 text-amber-200 border-amber-400/30"
      : "bg-gradient-to-r from-amber-300 to-amber-500 text-[#3F2D1B] border-amber-600/30 shadow-sm";
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-bold tracking-widest uppercase ${skin} ${className}`}
      title="VIP King · Royal seeker"
      data-testid="vip-king-badge"
    >
      <Crown size={11} weight="fill" />
      {label}
    </span>
  );
}
